import React, { memo } from "react";
import styled from "styled-components";
import { selectLoteriaImg } from "utils/config/reference";
import { map } from "lodash";
const GridView = ({
  grid,
  selectedType,
  handleSelectCell,
  readOnly = false,
  wheelSpinData = [],
  from="",
}) => {
  const checkCellStatus = (cell) => {

    const isInWheelSpin = wheelSpinData.find(
      (element) => element.id === cell.id
    );

    if(from === "studentDataView"){
      const checkData = wheelSpinData.some((element) => element.value === cell.value);
      if(checkData){
        return {
          shouldCross:checkData && cell.selected ? false :null
        };
      }
      return {
        shouldCross: cell.selected && !isInWheelSpin?.selected ? true : false,
      };
    }

    return {
      shouldCross: cell.selected && !isInWheelSpin?.selected ? true : false,
    };
  };

  return (
    <Container>
      <Grid  columns={grid?.length}>
        {map(grid,(row, rowIndex) =>
          map(row,(cell, colIndex) => {
            const { shouldCross } = checkCellStatus(cell);
            return (
              <Cell
                key={`${rowIndex}-${colIndex}`}
                onClick={() => {
                  if (readOnly) return;
                  handleSelectCell(rowIndex, colIndex);
                }}
                className="stuntImgCont"
                selected={cell.selected}
                backgroundColor={cell.backgroundColor}
                isImage={selectedType === "Image" || selectedType === "OnlyImage"}
                isLastColumn={colIndex === row.length - 1}
                isLastRow={rowIndex === grid.length - 1}
                readOnly={readOnly}
                shouldCross={shouldCross}
              >
                <div className="cell-with-coin-container">
                  <div
                    style={{
                      width: (selectedType === "Image" || selectedType === "OnlyImage") ? "137px" : "100px",
                      height: (selectedType === "Image" || selectedType === "OnlyImage") ? "137px" : "100px",
                    }}
                  >
                    {cell?.selected && (
                      <img
                        src={selectLoteriaImg}
                        alt="Selected"
                        style={{
                          width: "55px",
                          height: "55px",
                          position: "absolute",
                          top: "5px",
                          left: "5px"
                        }}
                      />
                    )}
                  </div>
                </div>
                {shouldCross && <CrossOverlay />}
                {selectedType === "Word" || selectedType === "Letter" ? (
                  <TextContent isLetter={cell.type === "Letter"}>
                    {cell.value}
                  </TextContent>
                ) : (selectedType === "Image" || selectedType === "OnlyImage") ? (
                  <>
                    <GridImage
                      className="grid-cell-image flex-1"
                      src={cell.imageUrl}
                      alt=""
                    />
                    {cell.value !== "" && (
                      <ImageCaption>{cell.value}</ImageCaption>
                    )}
                  </>
                ) : null}
              </Cell>
            );
          })
        )}
      </Grid>
    </Container>
  );
};

export default memo(GridView);

const CrossOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
  z-index: 1;

  &::before,
  &::after {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    width: 140%;
    height: 2px;
    background-color: red;
  }

  &::before {
    transform: translate(-50%, -50%) rotate(45deg);
  }

  &::after {
    transform: translate(-50%, -50%) rotate(-45deg);
  }
`;

const Container = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(${(props) => props.columns}, 150px);
  border: 3px dashed #080808;
  border-radius: 4px;
  overflow: auto;
`;

const Cell = styled.div`
  width: 150px;
  height: 150px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-align: center;
  overflow: hidden;
  background-color: ${(props) => props.backgroundColor};
  border: none;
  flex-direction: ${(props) => (props.isImage ? "column" : "row")};
  gap: ${(props) => (props.isImage ? "10px" : "0")};
  color: white;
  border-right: ${(props) =>
    props.isLastColumn ? "none" : "3px dashed #080808"};
  border-bottom: ${(props) =>
    props.isLastRow ? "none" : "3px dashed #080808"};
  cursor: ${(props) => (props.readOnly ? "default" : "pointer")};
  transition: background-color 0.2s ease;
  position: relative;
`;

const TextContent = styled.span`
  width: 100%;
  text-decoration: ${(props) => (props?.lineThrough ? "line-through" : "")};
  font-size: ${(props) => (props.isLetter ? "24px" : "16px")};
  color: ${(props) => (props?.lineThrough ? "red" : "")};
  text-decoration-color: ${(props) => (props?.lineThrough ? "red" : "")};
`;

const GridImage = styled.img`
  max-width: 100%;
  max-height: 100%;
  padding-top: 5px;
  padding-bottom: 5px;
  object-fit: contain;
`;

const ImageCaption = styled.div`
  width: 100%;
  background: #0b1442;
  color: white;
  padding: 4px;
`;
